<script>
  export default {
    name: 'import-progress',
    props: ['percent'],
    data () {
      return {}
    },
    computed: {},
    mounted () {},
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
  <div>
    <div><span class="text-center text-info">{{ percent }}%</span></div>
    <div class="progress progress-xs m-t-sm bg-white">
      <div class="progress-bar bg-info" :style="'width:' + percent + '%;'"></div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ImportProgress.vue?9fa5f88a